import { useLoginStatus } from "@website/hooks/auth-manager";
import Baloon from "@website/icons/components/baloon";
import Hotel from "@website/icons/components/hotel";
import HotelInternational from "@website/icons/components/hotel-international";
import VentureBus from "@website/icons/components/venture-bus";
import VentureFlight from "@website/icons/components/venture-flight";
import VentureFlightInt from "@website/icons/components/venture-flight-int";
import VentureTrain from "@website/icons/components/venture-train";
import Villa from "@website/icons/components/villa";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { useLoginModal } from "@website/widget/login";
import { useState } from "react";

const products: Record<string, string> = {
  "/": "DH",
  "/train": "Train",
  "/inter-flights": "IF",
  "/flights": "DF",
  "/villa": "Villa",
  "/bus": "Bus",
  "/bus-international": "IB",
  "/profile": "Profile",
  "/tour": "Tour"
};

export const useMyTrips = () => {
  const [purchaseMenuIsOpen, setPurchaseMenuIsOpen] = useState(false);
  const router = useCompatRouter();
  const { onLoginModalOpen } = useLoginModal();

  function onPurchaseMenuOpen() {
    window?.webengage?.track("mytrips-clicked", {
      source: process.env.NEXT_PUBLIC_APP_NAME
    });
    setPurchaseMenuIsOpen(true);
  }

  function onPurchaseMenuClose() {
    setPurchaseMenuIsOpen(false);
  }

  const { isLoggedIn } = useLoginStatus();
  const onClickHandler = (selectedService: string, event: string) => {
    window?.webengage?.track(event, {
      source: process.env.NEXT_PUBLIC_APP_NAME
    });
    const query = {
      ...router.query,
      my_trips_tab: "0",
      selected_service: selectedService,
      source: String(process.env.NEXT_PUBLIC_APP_NAME),
      product: products[router?.pathname] || ""
    };
    const queryString = new URLSearchParams(query).toString();

    const profileUrl = `/profile/my-trips${
      queryString ? `?${queryString}` : ""
    }`;

    if (isLoggedIn) {
      window.location.href = profileUrl;
    } else {
      onLoginModalOpen().then(() => {
        window.location.href = profileUrl;
      });
    }
  };

  const purchaseList = [
    {
      type: "button",
      title: "هتل داخلی",
      icon: <Hotel />,
      onClick: () => onClickHandler("HOTEL", "DH-mytrips-clicked")
    },
    {
      type: "button",
      title: "هتل خارجی",
      icon: <HotelInternational />,
      onClick: () => onClickHandler("INTER_HOTEL", "IH-mytrips-clicked")
    },
    {
      type: "button",
      onClick: () => onClickHandler("FLIGHT", "DF-mytrips-clicked"),
      title: "پرواز داخلی",
      icon: <VentureFlight />
    },
    {
      type: "button",
      title: "پرواز خارجی",
      icon: <VentureFlightInt />,
      onClick: () => onClickHandler("INTER_FLIGHT", "IF-mytrips-clicked")
    },
    {
      type: "button",
      onClick: () => onClickHandler("BUS", "Bus-mytrips-clicked"),
      title: "اتوبوس",
      icon: <VentureBus />
    },
    {
      type: "button",
      title: "قطار",
      icon: <VentureTrain />,
      onClick: () => onClickHandler("TRAIN", "Train-mytrips-clicked")
    },
    {
      type: "button",
      title: "ویلا",
      icon: <Villa />,
      onClick: () => onClickHandler("VILLA", "Villa-mytrips-clicked")
    },
    {
      type: "button",
      title: "تور",
      icon: <Baloon />,
      onClick: () => onClickHandler("TOUR", "Tour-mytrips-clicked")
    }
  ];

  return {
    purchaseList,
    onPurchaseMenuOpen,
    onPurchaseMenuClose,
    purchaseMenuIsOpen
  };
};
